import { render, staticRenderFns } from "./TermsInApp.vue?vue&type=template&id=945d23e8&scoped=true&"
import script from "./TermsInApp.vue?vue&type=script&lang=js&"
export * from "./TermsInApp.vue?vue&type=script&lang=js&"
import style0 from "./TermsInApp.vue?vue&type=style&index=0&id=945d23e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945d23e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
